import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { IAppState } from 'store/main';
import type { AppDispatch } from 'store/index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IAppState> = useSelector;
